import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders, buildError, API } from '../../api/apis';
import { ApiResponse, GetFederatedAccessRequest, GetFederatedAccessResponse, SetFederatedAccessRequest } from '../../interfaces/interfaces';

// Define the RTK Query service for settings
export const userFederationsService = createApi({
  reducerPath: 'federationsApi',
  tagTypes: ['Federation'],
  baseQuery: fetchBaseQuery({
    prepareHeaders: prepareHeaders,
  }),
  endpoints: (builder) => ({
    getUserFederation: builder.query({
      query: (request: GetFederatedAccessRequest) => {
        const result = API.FETCH_USER_FEDERATION(request);
        return result || ''; // Ensure a valid string is returned
      },
      providesTags: ['Federation'],
      transformResponse: (response: ApiResponse) => {
        return response.Response as GetFederatedAccessResponse;
      },
      transformErrorResponse: (response) => {
        return buildError(response, "");
      },
    }),
    updateUserFederation: builder.mutation({
      query: (request: SetFederatedAccessRequest) => ({
        url: API.UPDATE_USER_FEDERATION(),
        method: 'POST',
        body: request,
      }),
      invalidatesTags: ['Federation'],
      transformResponse: (response: ApiResponse) => {
        return response.Response as GetFederatedAccessResponse;
      },
      transformErrorResponse: (response) => {
        return buildError(response, "");
      },
    }),
  }),
});

// Export hooks for usage in functional components
export const { useGetUserFederationQuery, useUpdateUserFederationMutation } = userFederationsService;
